import Tooltip from '@mui/material/Tooltip';
import { Box, Typography, Grid } from "@mui/material";
import { Colors } from "assets/colors";
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import AddUserModal from "components/UserManagement/AddUserModal/AddUserModal";

const boxStyle = {
  borderRadius: "5px",
  border: `1px solid ${Colors.BorderGray}`,
  backgroundColor: "white",
  color: Colors.BlackText,
  padding: 0,
}

const header = {
  padding: "1rem",
  backgroundColor: Colors.GrayIconBox,
  fontSize: ".8rem"
}

const listContainer = {
  display: "flex",
  padding: "1rem",
  flexDirection: "column",
}

const actions = {
  padding: ".5rem 1rem",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: Colors.GreenIconBox,
    color: Colors.Green
  }
}



export default (props: any) => {

  let products = (props.value !== null && props.value.length > 0) ? props.value.map((p: any) => p.application) : [];
  let roles = (props.value !== null && props.value.length > 0) ? props.value.map((p: any) => p.roleName) : [];

  const onlyUnique = (value: any, index: number, self: any) => {
    return self.indexOf(value) === index;
  }

  let uniqueProducts = products.filter(onlyUnique) || [];
  let uniqueRoles = roles.filter(onlyUnique) || [];

  const customToolTip = (products: Array<string>, roles: Array<string>) => {
    return (
      <Box>
        <Typography sx={header}>{products.length} Applications</Typography>
        <Box sx={listContainer}>
          {products.map((p, i) => <Typography key={i} sx={{ fontSize: ".8rem" }}>{p}</Typography>)}
        </Box>
        <Typography sx={header}>{roles.length} Roles</Typography>
        <Box sx={listContainer}>
          {roles.map((p, i) => <Typography key={i} sx={{ fontSize: ".8rem" }}>{p}</Typography>)}
        </Box>
      </Box>
    )
  }

  const settingsTip = () => {
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography sx={{
          ...actions, "&:hover": {
            backgroundColor: Colors.GreenIconBox,
            color: Colors.Green
          }
        }}
          onClick={() => props.editAction("editUser", props.data)}
        >
          Update{/* Edit User */}
        </Typography>
        <Typography
          sx={{
            ...actions, "&:hover": {
              backgroundColor: Colors.RedIconBox,
              color: Colors.Red
            }
          }}
          onClick={() => props.deleteAction("deleteUser", { name: props.data.firstName, id: props.data.userId })}
        >
          Delete{/* Delete User */}
        </Typography>

      </Box>
    )
  }


  return (
    <>
      <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip
          title={customToolTip(uniqueProducts, uniqueRoles)}
          placement="bottom" componentsProps={{
            tooltip: {
              sx: boxStyle,
            },
          }}
        >
          <Grid item xs={8}>
            <p
              style={{
                color: "#0084FF",
                cursor: "pointer"
              }}
            >
              {uniqueProducts && uniqueProducts.length > 0 ? uniqueProducts.length : 0} applications, {uniqueRoles && uniqueRoles.length > 0 ? uniqueRoles.length : 0} roles
            </p>
          </Grid>

        </Tooltip>
        {props.data.createdBy !== "system" &&
          <Grid item xs={4} sx={{ display: "none", alignItems: "center", cursor: "pointer" }}>
            <Tooltip
              title={settingsTip()}
              placement="bottom" componentsProps={{
                tooltip: {
                  sx: boxStyle,
                },
              }}
            >
              <MoreHorizOutlinedIcon sx={{ margin: "0 2rem" }} />
            </Tooltip>
          </Grid>
        }

      </Grid>
    </>

  );
};
